import gql from "graphql-tag";

const userListPledge = gql`
  query listUserPledges {
    listUserPledges {
      poolId
      userId
      walletId
      whitelist
    }
  }
`;

export default userListPledge;
